/**
 * Email utility functions
 * Helper functions for email address manipulation and transformation
 */

/**
 * Normalizes an email address to lowercase and trims whitespace.
 * This ensures consistent email handling across the app, preventing
 * case-sensitivity issues with notification tokens and backend lookups.
 *
 * @param email - The email address to normalize
 * @returns The normalized email in lowercase, or empty string if input is falsy
 *
 * @example
 * normalizeEmail('TestUser@Gmail.COM') // returns 'testuser@gmail.com'
 * normalizeEmail('  user@example.com  ') // returns 'user@example.com'
 * normalizeEmail(null) // returns ''
 */
export function normalizeEmail(email: string | undefined | null): string {
	if (!email) return '';
	return String(email).toLowerCase().trim();
}
